module.exports = __webpack_public_path__ + "img/sustainabilityGold.27cda35.webp";